export const EM_DASH = '\u2014';

export const formatDaysValue = (days: number | null | undefined): string => {
  if (days == null || isNaN(days)) return EM_DASH;
  return `${days.toFixed(1)} days`;
};

export const formatPercentage = (value: number | null | undefined): string => {
  if (value == null || isNaN(value)) return EM_DASH;
  return `${value.toFixed(1)}%`;
};

export const formatDecimal = (value: number | null | undefined): string => {
  if (value == null || isNaN(value)) return EM_DASH;
  return value.toFixed(1);
};

export const formatWholeNumber = (value: number | null | undefined): string => {
  if (value == null || isNaN(value)) return EM_DASH;
  return String(value);
};
